import * as React from 'react';
import { MediaSet } from '../types/media';

export type ProductId = string;

export interface Product {
	readonly id: ProductId;
	readonly itemNo?: string | null;
	readonly name: string;
	readonly brand: string;
	readonly url?: string | null;
	readonly image: MediaSet;
	readonly price?: number;
}

export interface UseProductHook {
	(productId: null | ProductId): null | Product;
}

const UseProductHookContext = React.createContext<UseProductHook>(() => {
	console.error(`Product was requested, but no instance of <ProductProvider> was found.`);
	return null;
});

export interface ProductProviderProps extends React.PropsWithChildren {
	readonly hook: UseProductHook;
}

export const ProductProvider: React.FC<ProductProviderProps> = ({ hook, children }) => {
	return <UseProductHookContext.Provider value={hook}>{children}</UseProductHookContext.Provider>;
};

export const useProduct = (productId: null | ProductId): null | Product => {
	const useProductHook = React.useContext(UseProductHookContext);
	return useProductHook(productId);
};
